import { render, staticRenderFns } from "./HeaderComponents.vue?vue&type=template&id=0fab7a08&scoped=true"
import script from "./HeaderComponents.vue?vue&type=script&lang=js"
export * from "./HeaderComponents.vue?vue&type=script&lang=js"
import style0 from "./HeaderComponents.vue?vue&type=style&index=0&id=0fab7a08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fab7a08",
  null
  
)

export default component.exports